import { useContext, useRef } from 'react'
import { GlobalNavigationContext } from 'Layouts/AuthBaseLayout'

export const GLOBAL_SIDE_NAV_ID = 'studio-global-side-nav-4YGdhQ'

export const isGlobalSideNavCollapsed = () => {
  const { collapsed } = useContext(GlobalNavigationContext)
  return collapsed
  // return document.getElementById(GLOBAL_SIDE_NAV_ID)?.getAttribute('data-collapsed') === 'true'
}
